<template>
  <section class="tv-screen masthead">
    <div class="container-fluid">
      <div class="row tv-screen-header py-5 align-items-center">
        <div class="col-lg-3">
          <img src="@/assets/imgs/allif-tv-screen.svg" class="img-fluid" />
        </div>
        <div class="col-lg-8">
            <h1>Alif Overseas Pvt. Ltd</h1>
            <ul class="list-inline my-4">
              <li>465 Subscribers</li>
              <li>229 Videos</li>
              <li>72K Views</li>
            </ul>
            <div>
              <button class="btn-secondary-red">Subscribe</button>
            </div>
          <!-- <div class="search-section">
            <div class="search-box">
              <div class="input-field">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Select a topic to watch on Aliff TV."
                />
                <div class="search-icon" @click="() => $router.push('/search/search')">
                  <img src="@/assets/imgs/search-icon.svg" class="img-fluid" />
                </div>
              </div>
              <div class="search-section-tags pt-3">
                <div class="search-tags">
                  <div
                    class="tag-label mb-3"
                    v-for="(data, index) in 4"
                    :key="index"
                  >
                    Best Courses
                  </div>
                </div>
                <div class="mt-xl-0">
                  <button class="btn-filter btn ml-auto">
                    <div>Filter</div>
                    <img
                      src="@/assets/imgs/filter.svg"
                      class="img-fluid pl-2"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="elfsight-app-375beab7-6e47-4011-ab64-ff30ff46f497"></div>

    </div>
  </section>
</template>

<script>
// If using require
// const ytch = require("yt-channel-info");

// If using import

import homeServices from "@/apiServices/youtube-api";

export default {
  // data() {
  //   return {};
  // },
  // methods: {
  //   info() {
  //   },
  // },
  // beforeMount() {
  //   console.log(homeServices)
  // },
};
</script>

<style>
.list-inline {
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
}
.list-inline li:not(:first-child):before {
  content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #fff;
    border-radius: 50%;
    margin: 0px 20px;
}
.yottie-widget-feed-section-pagination .swiper-pagination-bullet-active {
    background-color: var(--primary) !important;
    color: #fff !important;
}

.yottie-widget-video-classic {
    border: 2px solid #d0d0d0 !important;
    padding: 10px !important;
    border-radius: 10px !important;
}
span.yottie-widget-feed-section-pagination-bullet {
  height: 40px !important;
  width: 40px !important;
  line-height: 1.6 !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AllifTvScreen.vue